import { TimeOnly } from "@repo/rq-api-public";

export const formatTimeToUrl = (time: TimeOnly | undefined) =>
  time ? `${time.hour}:${time.minute}` : "";

export const formatTimeForApi = (time?: TimeOnly): string | undefined => {
  if (!time) return undefined;
  const hourStr = time.hour.toString().padStart(2, "0");
  const minuteStr = time.minute.toString().padStart(2, "0");
  return `${hourStr}:${minuteStr}`;
};

export function combineDateAndTime(date: Date, time?: TimeOnly): Date {
  if (!time) return date;
  const combined = new Date(date);
  combined.setHours(time.hour, time.minute, 0, 0);
  return combined;
}
